import Cookies from "js-cookie";

const cookieDomain = process.env.REACT_APP_COOKIE_HOST;
const removeCookieOptions = { path: "/", domain: cookieDomain };

const clientHubAccessTokenCookieName = "clientHubAccessToken";
const clientHubRefreshTokenCookieName = "clientHubRefreshToken";
class TokenService {

    isAuthenticated() {
        var token = Cookies.get(clientHubRefreshTokenCookieName);
        if (token) {
            return true;
        }
        return false;
    }

    logoutClientHub() {
        Cookies.remove(clientHubAccessTokenCookieName, removeCookieOptions);
        Cookies.remove(clientHubRefreshTokenCookieName, removeCookieOptions);
    }
}

export default new TokenService();
